function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M39.693 112.672L0 0v160h640l-168.69-18.824-95.08-22.857-40.895 24.471-61.341-39.261-82.812 30.656-61.342-30.924v24.201l-58.453-39.53-31.694 24.74z",
  fill: "#000"
});

var SvgManifestoBrokenGroundRight = function SvgManifestoBrokenGroundRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 160,
    viewBox: "0 0 640 160",
    preserveAspectRatio: "none",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQwIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDY0MCAxNjAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zOS42OTMzIDExMi42NzJMMCAwVjE2MEg2NDBMNDcxLjMxIDE0MS4xNzZMMzc2LjIzIDExOC4zMTlMMzM1LjMzNSAxNDIuNzlMMjczLjk5NCAxMDMuNTI5TDE5MS4xODIgMTM0LjE4NUwxMjkuODQgMTAzLjI2MVYxMjcuNDYyTDcxLjM4NjYgODcuOTMyOEwzOS42OTMzIDExMi42NzJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgManifestoBrokenGroundRight as ReactComponent };